module.exports = __webpack_public_path__ + "img/Maps.0941e782.png";